import axios from "axios";
import { useAdmin } from "./AdminContext";
import { QrCode, Trash2, Check, Copy, Edit2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AdminPromos() {
  const { promos, promosLoading, setPromoDialogOpen, handleDeletePromo, copyUrl, copiedId, openToggleDialog, formatDate, fetchPromos } = useAdmin();

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div><h2 className="font-heading text-2xl font-black uppercase">QR Code Promos</h2><p className="text-sm text-zinc-500 mt-1">Generate QR codes with discount promo codes</p></div>
        <button onClick={() => setPromoDialogOpen(true)} className="brutal-btn brutal-btn-tertiary text-sm flex items-center gap-2" data-testid="generate-qr-btn"><QrCode size={16} strokeWidth={2.5} /> Generate New QR Code</button>
      </div>
      {promosLoading ? (
        <div className="brutal-card h-64 animate-pulse" />
      ) : promos.length === 0 ? (
        <div className="brutal-card p-12 text-center" data-testid="no-promos">
          <QrCode size={48} className="mx-auto mb-4 text-zinc-300" strokeWidth={2.5} /><h3 className="font-heading text-lg font-bold mb-2">No Promo Codes</h3>
          <button onClick={() => setPromoDialogOpen(true)} className="brutal-btn brutal-btn-tertiary text-sm" data-testid="generate-first-qr-btn"><QrCode size={14} className="inline mr-2" strokeWidth={2.5} /> Generate QR Code</button>
        </div>
      ) : (
        <div className="overflow-x-auto" data-testid="promos-table-container">
          <table className="qr-table">
            <thead><tr><th>QR Code</th><th>Code</th><th>URL</th><th>Discount</th><th>Uses</th><th>Email Used</th><th>Date Issued</th><th>Date Used</th><th>Scans</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {promos.map(promo => (
                <tr key={promo.id} data-testid={`promo-row-${promo.id}`}>
                  <td><img src={`data:image/png;base64,${promo.qr_base64}`} alt={`QR ${promo.code}`} className="w-16 h-16 border-2 border-black" /></td>
                  <td><span className="font-mono font-bold text-sm tracking-wider">{promo.code}</span></td>
                  <td><div className="flex items-center gap-2 max-w-[200px]"><span className="text-xs truncate">{promo.url}</span><button onClick={() => copyUrl(promo.url, promo.id)} className="flex-shrink-0 hover:text-[#FF3366]">{copiedId === promo.id ? <Check size={14} className="text-green-600" /> : <Copy size={14} />}</button></div></td>
                  <td><span className="font-heading font-black text-lg text-[#FF3366]">{promo.promo_type === "material_only" ? "MAT" : `${promo.discount_percent}%`}</span></td>
                  <td>
                    <div className="flex items-center gap-1">
                      <span className="font-mono text-sm">{promo.times_used}/{promo.max_uses}</span>
                      <button onClick={async () => {
                        const newMax = prompt(`Set max uses for ${promo.code} (currently ${promo.max_uses}):`, promo.max_uses);
                        if (newMax && parseInt(newMax) >= 1) { try { await axios.put(`${API}/promo-codes/${promo.id}/max-uses`, { max_uses: parseInt(newMax) }); fetchPromos(); } catch(e) {  } }
                      }} className="text-zinc-400 hover:text-[#FF3366] p-0.5" data-testid={`edit-max-uses-${promo.id}`} title="Edit max uses"><Edit2 size={12} strokeWidth={2.5} /></button>
                    </div>
                  </td>
                  <td><span className="text-xs">{promo.used_by_email || "-"}</span></td>
                  <td><span className="text-xs">{formatDate(promo.created_at)}</span></td>
                  <td><span className="text-xs">{formatDate(promo.used_at)}</span></td>
                  <td><span className="font-mono font-bold text-sm">{promo.times_scanned}</span></td>
                  <td>
                    <button onClick={() => openToggleDialog(promo.id, promo.active)} className="cursor-pointer" data-testid={`toggle-status-${promo.id}`}>
                      {promo.active ? <Badge className="bg-[#00E5FF] text-black border-2 border-black rounded-none font-mono text-[10px] hover:opacity-80">Active</Badge> : <Badge className="bg-zinc-200 text-zinc-600 border-2 border-black rounded-none font-mono text-[10px] hover:opacity-80">Inactive</Badge>}
                    </button>
                  </td>
                  <td><button onClick={() => handleDeletePromo(promo.id)} className="text-red-500 hover:text-red-700"><Trash2 size={16} strokeWidth={2.5} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
